import Items from "./Items";
import Page from "./Page";
import { Capitalize } from "./utils";

let PageInstaller = {
  install(Vue, options = {}) {
    let { prefix = "template", router } = options;

    router.addRoutes([
      {
        path: `/${prefix}/:id`,
        name: Capitalize(prefix),
        component: Page,
        props: true,
      },
    ]);
  },
};

export { Items, Page, PageInstaller };
